var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableDeleteEventListener, AbortableSubmitEventListener, ChangeEventListener, DeleteEventListener, EditEventListener, SubmitEventListener, ValidateEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class DetailAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onEdit = new EditEventListener();
        /** @event */
        this.onBeforeSubmit = new AbortableSubmitEventListener();
        /** @event */
        this.onBeforeDelete = new AbortableDeleteEventListener();
        /** @event */
        this.onDelete = new DeleteEventListener();
        /** @event */
        this.onSubmit = new SubmitEventListener();
        /** @event */
        this.onBeforeCancel = new AbortableSubmitEventListener();
        /** @event */
        this.onCancel = new SubmitEventListener();
        /** @event */
        this.onChange = new ChangeEventListener();
        /** @event */
        this.onValidate = new ValidateEventListener();
    }
    getCancelExpression() {
        return this.state.cancelExpression;
    }
    setCancelExpression(cancelExpression) {
        this.setState({ cancelExpression });
    }
    canDelete() {
        return this.state.canDelete;
    }
    setCanDelete(canDelete) {
        this.setState({ canDelete });
    }
    canEdit() {
        return this.state.canEdit;
    }
    setCanEdit(canEdit) {
        this.setState({ canEdit });
    }
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
    getDeleteExpression() {
        return this.state.deleteExpression;
    }
    setDeleteExpression(deleteExpression) {
        this.setState({ deleteExpression });
    }
    getDensity() {
        return this.state.density;
    }
    setDensity(density) {
        this.setState({ density });
    }
    getDetailState() {
        return this.state.state;
    }
    setDetailState(state) {
        this.setState({ state });
    }
    getEditExpression() {
        return this.state.editExpression;
    }
    setEditExpression(editExpression) {
        this.setState({ editExpression });
    }
    getInitialState() {
        return this.state.initialState;
    }
    setInitialState(initialState) {
        this.setState({ initialState });
    }
    getKeyField() {
        return this.state.keyField;
    }
    setKeyField(keyField) {
        this.setState({ keyField });
    }
    isLoading() {
        return this.state.loading;
    }
    setLoading(loading) {
        this.setState({ loading });
    }
    getSaveExpression() {
        return this.state.saveExpression;
    }
    setSaveExpression(saveExpression) {
        this.setState({ saveExpression });
    }
    getValue() {
        return this.state.formRef?.getValue();
    }
    setValue(value) {
        this.state.formRef?.setValue(value);
    }
    cancel() {
        this.state.formRef?.onCancel();
    }
    submit() {
        this.state.formRef?.onSubmit();
    }
    isValid() {
        return this.state.formRef?.isValid() ?? false;
    }
    validate() {
        const [valid] = this.state.formRef?.validate(true, true) ?? [false];
        return valid;
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onEdit", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onBeforeSubmit", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onBeforeDelete", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onDelete", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onSubmit", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onBeforeCancel", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onCancel", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onChange", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DetailAPI.prototype, "onValidate", void 0);
export default DetailAPI;
//# sourceMappingURL=detail-api.js.map